export default "__VITE_ASSET__B5T$WsG9__"